module.exports = __webpack_public_path__ + "ptc_momoro_N1.78f13354.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_N1.jpg
// module id = pWHI
// module chunks = 0